export default __webpack_public_path__ + "static/media/running-free.2b76ab59.jpg";